import React, { useMemo } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import { CloudUpload } from '@material-ui/icons';
import { setSubtitleFileProps } from 'redux/actions/Convert';
import { useDispatch } from 'react-redux';

const maxSize = 30 * 1024 * 1024; // 30 MB

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '7px 20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#A1A8E866',
  color: 'white',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const UploadSubtitleDropZone = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const onDrop = file => {
    dispatch(setSubtitleFileProps(file[0]));
  };

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, rejectedFiles } = useDropzone({
    accept: '.srt, .sub, .sbv',
    onDrop,
    maxSize,
    disabled
  });

  const isFileTooLarge = rejectedFiles?.length > 0 && rejectedFiles[0]?.size > maxSize;

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept],
  );

  return (
    <Box>
      <Box {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <CloudUpload style={{ fontSize: 72 }} />
        <Typography>انتخاب فایل زیرنویس</Typography>
        {isFileTooLarge && <Typography color="red">بیشتر از 30 میگابایت مجاز نیست</Typography>}
      </Box>
    </Box>
  );
};

export default UploadSubtitleDropZone;
